import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-187becbd"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "daily-message" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "text-lg spartan-font" }, "Daily Message", -1))
const _hoisted_3 = { class: "text-base spartan-font" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "text-lg spartan-font close-button",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeDailyMessage && _ctx.closeDailyMessage(...args)))
    }, " x "),
    _hoisted_2,
    _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.dailyMessage), 1)
  ]))
}